const defaultState = {
    sortingLogic: {}
};

const storeAddressListReducer = (state = defaultState, action) => {

    switch (action.type) {
        case 'SAVE_ADDRESSLIST_FULFILLED': {
            return {
                ...state,
                addressList: action.payload
            };
        }
        default: {
            return state;
        }
    }
};

export default storeAddressListReducer;


// WEBPACK FOOTER //
// ./src/reducers/storeAddressList.js